export enum CHOICE_LIST_STATUS {
  NOT_LOADED = "",
  LOADING = "LOADING",
  READY = "READY",
  ERROR = "ERROR",
}

export interface CachedChoiceList {
  status: CHOICE_LIST_STATUS;

  data: any[]; // It can be any data here
}

export type CachedChoiceLists = Record<string, CachedChoiceList>;

export const getFooterFieldsCachedKey = (grouperType: string, pricerType: string) =>
  `FOOTER-FIELDS-${grouperType}-${pricerType}`;
